<template>
    <div>
        <ContactBase :contacts="contacts"></ContactBase>
    </div>
</template>
<script>

import ContactBase from '~/components/contact/Base.vue';

export default {
    name: "contact",
    layout: "default",
    components: {
        ContactBase
    },
    data: function () {
        return {
            contacts: {
                title: 'Customer Service',
                descriptionList: ['9 am - 5 pm Monday to Thursday', 'Phone: (845) 570-2713'],
                email: 'info@macherusa.com',
                socialMediaList: [
                    {
                        title: 'facebook',
                        icon: 'social-facebook',
                        link: 'https://www.facebook.com'
                    }
                ]
            }
        };
    },
    head() {
        const { path = "" } = this.$route;

        const metaTitle = 'Contact Us' + " | Macher Jobs";
        const metaDescription = "Contact Us | Macher Jobs"
        const canonical = process.env.baseUrl + path;

        return {
            title: metaTitle,
            link: [{ rel: "canonical", href: canonical }],
            meta: this.createMetaTags({
                description: metaDescription,
                title: metaTitle,
                canonical,
                socialTitle: metaTitle,
                socialDescription: metaDescription,
                siteName: "Macher Jobs",
                twitter: "@FrumJewishJobs",
            }),
        };
    },
};
</script>
